import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Instagram, Twitter, Linkedin, Mail, MapPin, ArrowRight } from 'lucide-react';

const Footer = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setEmail('');
      setTimeout(() => setSubscribed(false), 3000);
    }
  };

  return (
    <footer className="footer-enhanced">
      {/* Newsletter Section */}
      <div className="footer-newsletter">
        <div className="container">
          <div className="newsletter-content">
            <div className="newsletter-text">
              <h3>Stay Connected</h3>
              <p>Subscribe for exclusive updates, new releases, and brand stories</p>
            </div>
            <form className="newsletter-form" onSubmit={handleSubscribe}>
              <div className="input-3d">
                <input
                  type="email"
                  placeholder="Enter your email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button type="submit" className="btn-submit">
                  {subscribed ? '✓' : <ArrowRight size={20} />}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="footer-main">
        <div className="container">
          <div className="footer-grid-enhanced">
            {/* Brand Column */}
            <div className="footer-col footer-brand-col">
              <h3 className="footer-logo">ARKORA</h3>
              <p className="footer-tagline">
                {t('footer.tagline')}
              </p>
              <div className="footer-social">
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                  <Instagram size={20} />
                </a>
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Twitter">
                  <Twitter size={20} />
                </a>
                <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="LinkedIn">
                  <Linkedin size={20} />
                </a>
              </div>
            </div>

            {/* Navigation Column */}
            <div className="footer-col">
              <h4 className="footer-heading">Explore</h4>
              <nav className="footer-nav">
                <Link to="/portfolio" className="footer-link">{t('nav.portfolio')}</Link>
                <Link to="/philosophy" className="footer-link">{t('nav.philosophy')}</Link>
                <Link to="/global" className="footer-link">{t('nav.global')}</Link>
                <Link to="/about" className="footer-link">{t('nav.about')}</Link>
              </nav>
            </div>

            {/* Company Column */}
            <div className="footer-col">
              <h4 className="footer-heading">Company</h4>
              <nav className="footer-nav">
                <Link to="/contact" className="footer-link">{t('nav.contact')}</Link>
                <Link to="/contact" className="footer-link">Partnerships</Link>
                <Link to="/legal" className="footer-link">Legal</Link>
                <Link to="/legal#cookies" className="footer-link">Cookie Policy</Link>
              </nav>
            </div>

            {/* Contact Column */}
            <div className="footer-col">
              <h4 className="footer-heading">Contact</h4>
              <div className="footer-contact">
                <div className="contact-item">
                  <MapPin size={16} />
                  <span>4512G, 470 St Kilda Rd, Melbourne, VIC 3004</span>
                </div>
                <div className="contact-item">
                  <Mail size={16} />
                  <a href="mailto:ar@arkora.com.au">ar@arkora.com.au</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom-enhanced">
        <div className="container">
          <div className="footer-bottom-content">
            <p className="copyright">{t('footer.copyright')}</p>
            <div className="footer-legal">
              <Link to="/legal">Legal Notice</Link>
              <Link to="/legal#privacy-commitment">Privacy Policy</Link>
              <Link to="/legal#cookies">Cookie Consent</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
